import { render, staticRenderFns } from "./ConfigTiposCambios.vue?vue&type=template&id=7258a957&scoped=true"
import script from "./ConfigTiposCambios.vue?vue&type=script&lang=js"
export * from "./ConfigTiposCambios.vue?vue&type=script&lang=js"
import style0 from "./ConfigTiposCambios.vue?vue&type=style&index=0&id=7258a957&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7258a957",
  null
  
)

export default component.exports